const removeDuplicates = (arr, key) => {
  return Array.from(new Set(arr.map((a) => a[key]))).map(
    (id) => {
      return arr.find((a) => a[key] === id);
    }
  );
};

export const mapListToDropdownList = (list, {keys, values, texts}, allOption = false) => {
  if (list) {
    const listDropdown = [{
      'key': '',
      'value': '',
      'text': 'TODOS',
    }];

    const listData = list.map((item) => {
      const itemKey = keys.map((key) => item[key]).join('-');
      const itemValues = keys.map((key) => item[values]).join('-');
      const itemTexts = keys.map((key) => item[texts]).join('-');
      return {
        'key': itemKey,
        'value': itemValues,
        'text': itemTexts || '(Sin nombre)',
      };
    });
    const listWithoutDuplicates = removeDuplicates(listData, 'key');

    if (allOption) {
      return listDropdown.concat(listWithoutDuplicates);
    }
    return listWithoutDuplicates;
  }
  return [];
};
